<ui-page-header [pageTitle]="'Katalog typu oprávnění k zastupování'" [dataCy]="Cy_Katalog.title">
  <reza-seznam-sablon-overview-filter></reza-seznam-sablon-overview-filter>
</ui-page-header>
